import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { defineStyles, theme } from '../theme';
const styles = defineStyles({
    root: {
        minWidth: 120,
    },
    select: {
        textTransform: 'lowercase',
        '& .MuiSelect-select': {
            textWrap: 'nowrap',
        },
    },
    disabled: {
        cursor: 'not-allowed',
        color: theme.vars.palette.grey[600],
    },
});
function renderItemLabel(item) {
    if (typeof item.label === 'function') {
        return item.label();
    }
    if (item.label != null) {
        return item.label;
    }
    return item.value;
}
export const FilteringDropdown = ({ items, onSelectedItemChange, placeholder, value, sx, disabled, }) => {
    const selectedItem = value != null ? items.find((item) => item.value === value) ?? null : null;
    const displayValue = value ?? '';
    return (_jsx(Box, { sx: { ...styles.root, ...sx, ...(disabled && styles.disabled) }, children: _jsx(FormControl, { fullWidth: true, size: "small", disabled: disabled, variant: "outlined", sx: { minWidth: 120 }, children: _jsx(Select, { value: displayValue, onChange: (e) => {
                    const newValue = e.target.value;
                    const item = newValue ? items.find((i) => i.value === newValue) : undefined;
                    onSelectedItemChange(item);
                }, displayEmpty: true, renderValue: () => {
                    if (selectedItem)
                        return renderItemLabel(selectedItem);
                    return placeholder;
                }, sx: styles.select, children: items.map((item) => (_jsx(MenuItem, { value: item.value, disabled: item.disabled, children: renderItemLabel(item) }, item.value))) }) }) }));
};
//# sourceMappingURL=FilteringDropdown.js.map